import Stack from '@mui/material/Stack';
import React from 'react';
import PropTypes from 'prop-types';

import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  Button,
  Box,
  Container,
} from '@mui/material';

import { useLangFile } from 'js/context/LanguageContext';

const SuspendStationDialog = ({ shown, onClose, onYes, onNo }) => {
  const LangFile = useLangFile();

  return (
    <Dialog open={shown} maxWidth={'md'} fullWidth onClose={onClose}>
      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            pt: 4,
          }}
        >
          <Box
            sx={{
              color: 'secondary.main',
              fontWeight: 500,
              fontSize: 27,
            }}
          >
            {LangFile.SuspendStationDialog.title1}
          </Box>
          <Box
            sx={{
              fontWeight: 500,
            }}
          >
            {LangFile.SuspendStationDialog.title2}
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              px: 2,
              pb: 3,
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box>{LangFile.SuspendStationDialog.description1}</Box>
            <Box>{LangFile.SuspendStationDialog.description2}</Box>
            <Box>{LangFile.SuspendStationDialog.description3}</Box>
          </Box>

          <Container maxWidth={'sm'}>
            <Box
              sx={{
                my: 1,
              }}
            >
              <Button
                variant={'contained'}
                size={'large'}
                fullWidth
                color={'primary'}
                onClick={onNo}
              >
                <Stack
                  direction={'column'}
                  sx={{
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    sx={{
                      fontWeight: 600,
                      fontSize: 20,
                    }}
                  >
                    {LangFile.SuspendStationDialog.no}
                  </Box>
                  <Box
                    sx={{
                      fontWeight: 400,
                    }}
                  >
                    {LangFile.SuspendStationDialog.noDescription}
                  </Box>
                </Stack>
              </Button>
            </Box>

            <Box
              sx={{
                my: 1,
              }}
            >
              <Button
                variant={'outlined'}
                size={'large'}
                fullWidth
                color={'secondary'}
                onClick={onYes}
              >
                <Stack
                  direction={'column'}
                  sx={{
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    sx={{
                      fontWeight: 600,
                      fontSize: 20,
                    }}
                  >
                    {LangFile.SuspendStationDialog.yes}
                  </Box>
                  <Box
                    sx={{
                      fontWeight: 400,
                    }}
                  >
                    {LangFile.SuspendStationDialog.yesDescription}
                  </Box>
                </Stack>
              </Button>
            </Box>
          </Container>
        </Box>
      </DialogContent>

      <DialogActions>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Button variant={'outlined'} onClick={onClose}>
            {LangFile.SuspendStationDialog.back}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

SuspendStationDialog.propTypes = {
  shown: PropTypes.bool,
  onClose: PropTypes.func,
  onYes: PropTypes.func,
  onNo: PropTypes.func,
};

export default SuspendStationDialog;
